<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-send-request"></div>
    </div>
    <h2 *ngIf="portalTitleText">{{portalTitleText}}</h2>
    <div class="account-payment-request-dialog__body" *ngIf="portalBodyText">
      <span>{{portalBodyText}}</span>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button a11y_Button mat-flat-button (click)="confirm()">
              <span langkey="phAccountPayment_ButtonRequestActivation"></span>
            </button>
          </div>
          <div class="ya-button-container">
            <button a11y_Button mat-stroked-button (click)="cancel()">
              <span [langkey]="cancelButtonLangkey"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
